import React, { useEffect, useState } from "react"
import { Header, Button, Divider } from "semantic-ui-react"
import ca_x_instacart from "./../../images/ca-x-instacart.svg"
import caPhoneIcon from "../../images/ca-phone-icon.svg"
import infoOutlined from "../../images/info-outlined-icon.svg"
import supportIcon from "../../images/support-icon.svg"
import helpIcon from "../../images/help-icon.svg"
import { connect } from "react-redux"
import green_check from "./../../images/green-check.png"
import request_timer from "./../../images/request_timer.png"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClock } from "@fortawesome/pro-solid-svg-icons"
import instacartDiscountIcon from "../../images/instacart_discount_icon.svg"
import moment from "moment"
import { HOUR, HOURS } from "../../v1/constants/tires"
import { DATE_TIME_FORMAT } from "../../v1/constants/application"
import { withTranslation } from "react-i18next"
import { gaJSON, trackFirebaseAnalytics } from "../../shared_component/utils/googleAnalyticsHelpers"
import { fetchActiveOrders, me } from "../../v1/actions/user"
import CarAdviseLogo from "../../images/CarAdvise-Logo.svg"
import caShortLogo from "../../images/ca-orange-short.svg"
import { EBAY, INSTACART, INSTACART_CANADA } from "../../v1/constants/affiliations"
import AddToCalendarButton from "./AddToCalendarButton"
import { getApiBaseUrl } from "../../shared_component/utils/urlUtils"
import { ReactComponent as MapPin } from "../../images/map-pin.svg"
import { ReactComponent as CalendarIcon } from "../../images/appointment-only.svg"
import { faCar } from "@fortawesome/pro-regular-svg-icons"
import { showDateTime } from "./Dashboard/NewUpcomingAppointmentCard"
import store from "../../shared_component/utils/configureStore"
import { isEbay } from "../../v1/helpers/affiliationHelpers"
import { ReactComponent as Tires } from "../../images/tires.svg"
import { getSubdomain } from "../../v1/components/Config/StylesheetInjector"
import { isEbayTireOrder } from "../../v1/helpers/orderHelpers"
import { ReactComponent as InfoIcon } from "../../images/info-Icon.svg"
import { ReactComponent as CalenderTick } from "../../images/calender-tick.svg"

const AppointmentConfirmation = ({ order = {}, history, t, fetchActiveOrders, user }) => {
  const [event, setEvent] = useState()

  const order_services = order.order_services || []

  const isInstacartUser = [INSTACART, INSTACART_CANADA].includes(
    user?.affiliation?.root_reference_id
  )

  useEffect(() => {
    buildEvent()
  }, [order])

  useEffect(() => {
    fetchActiveOrders()
  }, [])

  const goToDashboard = async () => {
    await store.dispatch(me())
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_go_to_dashboard
    })
    if (isEbay()) {
      history.push(`/shop_orders/${order.id}/review`)
    } else {
      history.push("/dashboard")
    }
  }

  const buildEvent = () => {
    const shop = order.shop

    if (shop) {
      const start = moment(order.appointment_datetime)
      const end = start.clone().add(1, HOUR)
      const duration = end.diff(start, HOURS)
      const orderServices = order_services
        .map(function (service, index) {
          return `${index + 1}. ${service.name}`
        })
        .join("\n")
      const description = `${shop.name} ${shop.address_line1} ${shop.city}, ${shop.state} ${shop.zip}\\n\\nServices:\\n${orderServices}\\n\\nCarAdvise Support:\\nsupport@caradvise.com\\n(844) 923-8473`
      const baseURL = getApiBaseUrl()
      let eventFormed = {
        title: `CarAdvise Appointment - ${shop.name}`,
        startDate: start.format(DATE_TIME_FORMAT.YYYY_MM_DD),
        startTime: start.format(DATE_TIME_FORMAT.HH_M),
        endDate: end.format(DATE_TIME_FORMAT.YYYY_MM_DD),
        endTime: end.format(DATE_TIME_FORMAT.HH_M),
        timezone: shop.time_zone,
        duration: `${duration}`,
        description: description,
        location: `${shop.address_line1} ${shop.city}, ${shop.state} ${shop.zip}`,
        iCalFileName: `CarAdvise Appointment - ${shop.name}`,
        linkToOrder: `${baseURL}/#/shop_orders/${order?.id}/review`
      }
      setEvent(eventFormed)
    }
  }

  let appointmentStatusText = "Appointment details"
  let appointmentStatus = () => {
    return (
      <div className="appt-status">
        <Header as="h4" className="appt-status-text">
          <p className="appt-status-label">{t("appointmentConfirmed")}</p>
        </Header>
        <img src={green_check} />
      </div>
    )
  }
  if (order.status === "walk_in") {
    appointmentStatusText = "Walk-in details"
    appointmentStatus = () => {
      return (
        <div className="appt-status">
          <Header as="h4" className="appt-status-text">
            <p className="appt-status-label">{t("walkinConfirmation")}</p>
          </Header>
          <img src={green_check} />
        </div>
      )
    }
  }
  if (order.status === "initiated" || order.status === "initiated_by_user") {
    appointmentStatusText = "Appointment request details"
    appointmentStatus = () => {
      return (
        <div className="appt-status">
          <Header as="h4" className="appt-status-text">
            <p className="appt-status-label">{t("appointmentRequested")}</p>
          </Header>
          <img src={request_timer} />
        </div>
      )
    }
  }

  let appointmentStatusBanner = () => {
    if (user.country === "ca" || order.status === "walk_in") {
      return (
        <div className="row-flex-start need-to-reschedule-container">
          <InfoIcon width={30} />
          <div style={{ lineHeight: "18px" }}>
            <b>{t("thisServiceIsNotAConfirmedAppointment")} </b>
            {t("waitTimesMayVary")}
          </div>
        </div>
      )
    }

    return null
  }

  let vehicleName = ""
  if (order.vehicle != null) {
    const vehicle = order.vehicle
    if (vehicle.year != null) {
      vehicleName += order.vehicle.year + " "
    }
    if (vehicle.make != null) {
      vehicleName += order.vehicle.make + " "
    }
    if (vehicle.model != null) {
      vehicleName += order.vehicle.model + " "
    }
  }

  let appointmentTime = " | " + order.appointment_time_pretty
  if (order.status === "walk_in") {
    appointmentTime = ""
  }

  const shopAccountNumber = order?.company?.national_account_number || ""
  return (
    <div
      style={{
        margin: "10px 10px 60px 10px"
      }}
    >
      <div className="appointment-confirmation-container">
        <img className="ca-x-ic-image" src={isInstacartUser ? ca_x_instacart : CarAdviseLogo} />
        {appointmentStatus()}
        {appointmentStatusBanner()}
        {isEbayTireOrder(order) && (
          <div
            className="row-flex-start need-to-reschedule-container"
            style={{ marginTop: "10px" }}
          >
            <img src={infoOutlined} />
            <div style={{ lineHeight: "18px" }}>
              Please remember to check your eBay order for shipping updates to ensure your tires
              have arrived before your appointment.
            </div>
          </div>
        )}
        {(order.status === "initiated" || order.status === "initiated_by_user") && (
          <div
            className="row-flex-start need-to-reschedule-container"
            style={{ color: "#B83614", backgroundColor: "#FEF6F4" }}
          >
            <FontAwesomeIcon icon={faClock} style={{ paddingRight: "5px" }} />
            <div style={{ lineHeight: "18px" }}>
              <b>{t("awaitingConfirmation")}</b> {t("youllBeNotifiedByTextOrPhone")}
            </div>
          </div>
        )}
        <Divider style={{ margin: 0 }} />
        <p className="appointment-status-title">{appointmentStatusText}</p>
        <div className="appt-details">
          {order.vehicle && (
            <div className="row-flex-start">
              <FontAwesomeIcon icon={faCar} />
              <p className="label">{order.vehicle.name}</p>
            </div>
          )}
          <div className="vertical-padding-5 shop-details">
            <MapPin className="calendar-icon" />
            <div>
              <p className="label">{order.shop ? order.shop.name : ""}</p>
              <p className="margin-0 sub-text">{order.shop ? order.shop?.address_line1 : ""}</p>
              <p className="margin-0 sub-text">
                {order.shop ? `${order.shop?.city}, ${order.shop?.state}. ${order.shop?.zip}` : ""}
              </p>
            </div>
          </div>
          {/*{order.shop?.main_phone_number && (*/}
          {/*  <div className="row-flex-start">*/}
          {/*    <img src={phoneIcon} style={{ height: "16px", width: "16px" }} />*/}
          {/*    <p className="label">*/}
          {/*      {formatPhoneNumberDash(order.shop?.main_phone_number)}*/}
          {/*    </p>*/}
          {/*  </div>*/}
          {/*)}*/}
          {order.appointment_date_pretty && (
            <div className="appointment-date">
              <div className="row-flex-start" style={{ alignItems: "center" }}>
                <CalendarIcon className="calendar-icon" />
                <div className="label">{showDateTime(order, t)}</div>
              </div>
              <div className="add-to-calendar-container">
                <AddToCalendarButton {...event} style={{ position: "absolute", top: "-10px" }}>
                  <div className="add-to-calendar-btn">
                    <CalenderTick />
                    <p className="text-small-dark">Add to Calendar</p>
                  </div>
                </AddToCalendarButton>
              </div>
            </div>
          )}
          {isEbayTireOrder(order) && (
            <div className="vertical-padding-5 shop-details">
              <Tires style={{ width: "16px", height: "16px", marginTop: "5px" }} />
              <div className="text-start">
                <p className="label">Tires from eBay:</p>
                <p className="margin-0 sub-text">{order.tire_details}</p>
              </div>
            </div>
          )}
          {/*{shopAccountNumber && (*/}
          {/*  <>*/}
          {/*    <p className="label vertical-padding-5">{t("shopAccountNumber")}:</p>*/}
          {/*    <p className="ca-national-ac-number">{shopAccountNumber}</p>*/}
          {/*  </>*/}
          {/*)}*/}
        </div>
        {user &&
          user.country !== "ca" &&
          (order.status === "initiated" || order.status === "initiated_by_user") && (
            <>
              <div className="row-flex-start need-to-reschedule-container">
                <img src={infoOutlined} />
                <div className="need-to-reschedule-text">
                  <b>{t("needToReschedule")}</b>{" "}
                  {t("youCanEasilyManageYourAppointmentThroughTheDashboard")}
                </div>
              </div>
            </>
          )}
        {isInstacartUser && order?.promotions?.length > 0 && (
          <div className="discount-banner">
            <div className="row-flex-start discount-banner-text">
              <img src={instacartDiscountIcon} className="padding-right-10" />
              <div>
                {t("yourGuaranteedDiscount", {
                  discount:
                    order.promotions[0].discount_type === "percent"
                      ? order.promotions[0].discount + "%"
                      : "$" + order.promotions[0].discount
                })}
              </div>
            </div>
          </div>
        )}
        {!order?.no_order_service_has_shop_price && (
          <div>
            <div className="estimated-total-container">
              <p className="estimated-total">{t("estimatedTotal")}*</p>
              <p className="estimated-total">${order.estimated_total}</p>
            </div>
            <p className="estimated-total-disclaimer">
              *
              {t(
                "theFinalCostMayVaryBasedOnPartsAvailabilityYourSpecificVehicleAndAnyAdditionalServicesNeeded"
              )}
            </p>
          </div>
        )}
        <Button fluid basic color="black" className="secondary-button" onClick={goToDashboard}>
          <div className="font-weight-700">
            {getSubdomain() === EBAY ? "View my appointment" : t("goToMyDashboard")}
          </div>
        </Button>
        <Divider style={{ margin: 0 }} />
        <div className="whats-next">
          <b>{t("questionsOrConcerns")}</b> {t("ourSupportTeamIsHereToHelp")}
        </div>
        <div className="contact-details">
          <div className="row-flex-start align-center">
            <img src={supportIcon} style={{ paddingRight: "5px", height: "16px", width: "16px" }} />
            <p className="margin-0 email-link">
              <a href="mailto:support@caradvise.com">support@caradvise.com</a>
            </p>
          </div>
          <div className="row-flex-start align-center">
            <img src={caPhoneIcon} style={{ paddingRight: "5px", height: "16px", width: "16px" }} />
            <p className="margin-0">
              <a href="tel:+1-844-923-8473">844-923-8473</a>
            </p>
          </div>
        </div>
        {user && user.country === "ca" && (
          <a
            className="row-flex-start align-center"
            href="https://caradvise.com/faq/"
            style={{ textDecoration: "underline" }}
          >
            <img src={helpIcon} style={{ paddingRight: "5px", height: "16px", width: "16px" }} />
            <p className="margin-0">{t("clickHereToGetMoreInformation")}</p>
          </a>
        )}
      </div>
    </div>
  )
}

function mapStateToProps(state, props) {
  const user = state.user
  let order =
    user.active_orders &&
    user.active_orders.filter((o) => o.id === parseInt(props.match.params.id))[0]
  if (!order)
    order =
      user.closed_orders &&
      user.closed_orders.filter((o) => o.id === parseInt(props.match.params.id))[0]

  return {
    user: state.user,
    order: order
  }
}

export default connect(mapStateToProps, { fetchActiveOrders })(
  withTranslation("serviceRequest")(AppointmentConfirmation)
)
